import styled from 'styled-components';

export const ContainerForm = styled.div`
    margin: 20px 30px;
    padding: 20px;
    background: #fff; /
    border-radius: 8px;
    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
`;